export enum CheckboxVariant {
  default = 'default',
  blue = 'blue',
  target = 'target',
}
